import React, { Component } from 'react';
import { TextField, Button, InputAdornment } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search'
import { getDescendantProp } from './CommonFunctions';
const FlexSearch = require('flexsearch');

interface SearchBarProps { searchList: Array<{}>, fieldName: string, searchResults(results: Array<{}>, searching: boolean): void }
type State = {
    searchText: string
}

let typingTimer: NodeJS.Timeout | null
class SearchBar extends Component<SearchBarProps, State> {
    constructor(props: SearchBarProps) {
        super(props)

        this.index = new FlexSearch.create();
        props.searchList!.map((o: any, i: number) => this.index.add(i, getDescendantProp((o), props.fieldName)))
        
        this.state = {
            searchText: "",
        }
    }

    public index: any

    public triggerSearch = () => {
        if (typingTimer !== null) {
            clearTimeout(typingTimer)
        }
        let doneTypingInterval = 350
        typingTimer = setTimeout(() => {
            let resultsId = this.index.search(this.state.searchText, 50)
            let results = resultsId.map((i: number) => this.props.searchList![i])
            if (results.length === 0)
                if (this.state.searchText === '')
                    this.props.searchResults([], false)
                else this.props.searchResults([], true);
            else this.props.searchResults(results, true)
        }, doneTypingInterval)
    }

    render() {

        return (
            <TextField
                onChange={(e) => { this.setState({ searchText: e.target.value }); this.triggerSearch(); }}
                value={this.state.searchText}
                variant="outlined"
                style={{ width: '100%', marginTop: '10px' }}
                inputProps={{
                    style: {
                        padding: '8px 14px'
                    }
                }}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            <Button variant="contained"
                                style={{
                                    width: '35px', height: '35px',
                                    minWidth: 0,
                                    borderRadius: '100px',
                                    boxShadow: 'none',
                                    marginRight: '-14px',
                                    color: 'primary',
                                    backgroundColor: 'white'
                                }}
                                onClick={() => this.triggerSearch()}
                            >
                                <SearchIcon />
                            </Button>
                        </InputAdornment>
                    ),
                }}
            />
        )
    }
}

export default SearchBar;